import { render, staticRenderFns } from "./InfoField.vue?vue&type=template&id=1e6e2868&scoped=true&"
import script from "./InfoField.vue?vue&type=script&lang=js&"
export * from "./InfoField.vue?vue&type=script&lang=js&"
import style0 from "./InfoField.vue?vue&type=style&index=0&id=1e6e2868&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6e2868",
  null
  
)

export default component.exports